import ModalCadastroUnidade from "./ModalCadastroUnidade";

interface EditUnidadeProps {
  unidadeEditId?: string;
  isOpenModal: boolean;
  tenantId: string;
  onClose: () => any;
  onSuccess?: () => any;
}

function EditUnidade({
  unidadeEditId,
  isOpenModal,
  onSuccess,
  tenantId,
  onClose,
}: EditUnidadeProps) {
  return (
    <>
      {isOpenModal ? (
        <ModalCadastroUnidade
          isOpen={isOpenModal}
          tenantId={tenantId}
          id={unidadeEditId}
          onClose={onClose}
          onSaved={onSuccess}
        />
      ) : null}
    </>
  );
}

export default EditUnidade;
